'use strict';
const { appendToUrl } = require('../common/urlUtil');

function addDropdownFix() {
    // add code to fix dropdown only if not present already.
    var fixAlreadyPresent = $._data(document, "events").keydown.some(e => e.namespace === 'fixdropdown');
    if (!fixAlreadyPresent){
        $(document).on('keydown.fixdropdown', (e)=>{
            if (e.key === 'Tab'){
                $('.dropdown-toggle').attr('tabindex', '0');
            }
        });

        $(document).on('keydown.fixdropdown', '.dropdown:not(.show) .dropdown-toggle', function(e){
            if (e.key === 'Enter' || e.key === ' ') {
                // trigger click and move focus to dropdown items
                $(this)[0].click();
                var $menu = $(this).siblings('.dropdown-menu');
                $menu.find('.dropdown-item')[0].focus();
            }
        });

        $(document).on('keydown.fixdropdown', '.dropdown-item', function(e){
            if (e.key === 'Enter' || e.key === ' ') {
                $(this)[0].click();
            }
        });
    }
}

module.exports = function () {
    // open pop-up
    $(document).on('click', '.js-locale-show', function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        if (!$(this).hasClass('js-complete-upload')) {
            $(this).addClass('js-complete-upload');
            $.spinner().start();
            var urlPopUp = $(document).find('.js-lazyload-popUp').data('action-url');
            $.ajax({
                url: urlPopUp,
                success: function(data) {
                    $(document).find('.js-lazyload-popUp').html(data.popUpTemplate);
                    $('.selectpicker').each(function() {
                        $(this).css({
                            display: 'none'
                        });
                        var label;
                        // set button id for label
                        if (this.labels.length > 0) {
                            label = this.labels[0].innerText;
                        } else {
                            label = $(this).closest('.cc-form-group').find('.cc-label').html();
                        }
                        var $button = $(this).siblings('button');
                        $button.attr('aria-label', label);
                        $(this).selectpicker('refresh');
                        // fix voice over
                        $(this).parent().find('.dropdown-toggle').removeAttr('role');
                    });
                    $('.js-update-PopUp-selectLanguages').html(data.imgPopUp);
                    var imgPath;
                    if (($('body').hasClass('cc-desktop')) && ($('#js-img-desktop').length > 0)) {
                        imgPath = $('#js-img-desktop').val();
                        $('.js-select-language-img').attr('src', imgPath);
                    } else if (($('body').hasClass('cc-tablet')) && ($('#js-img-tablet').length > 0)) {
                        imgPath = $('#js-img-tablet').val();
                        $('.js-select-language-img').attr('src', imgPath);
                    } else if (($('body').hasClass('cc-mobile')) && ($('#js-img-mobile').length > 0)) {
                        imgPath = $('#js-img-mobile').val();
                        $('.js-select-language-img').attr('src', imgPath);
                    }
                    $('.js-locale-popup').show();
                    $('body').addClass('cc-blocked');
                    addDropdownFix();
                    $.spinner().stop();
                    $('.cc-locale-popup-content-form')[0].focus();
                    var localeCode = $('.js-changelocale-popup-content').attr('data-currentlocale');
                    $('body').trigger('analytics:pushgeolocationbanner', {eventCategory: 'changelocale', eventAction: 'start', eventLabel: localeCode});
                }
            });
        } else {
            $('.js-locale-popup').show();
            $('body').addClass('cc-blocked');
            $('.cc-locale-popup-content-form')[0].focus();
            var localeCode = $('.js-changelocale-popup-content').attr('data-currentlocale');
                    $('body').trigger('analytics:pushgeolocationbanner', {eventCategory: 'changelocale', eventAction: 'start', eventLabel: localeCode});
        }
        return false;
    });

    $(document).on('click', '.js-locale-overlay, .js-locale-popup-close', function (e) {
        e.preventDefault();

        $('.js-locale-popup').hide();
        $('.js-locale-switch-popup').hide();
        $('body').removeClass('cc-blocked');

        var url = $(this).data('action');
        var localeCode = $('.js-locale-mylocale').data('mylocale');
        var type = 'no';
        var action = $('.page').data('action') !== null ? $('.page').data('action') : '';
        var querystring = $('.page').data('querystring') !== null ? $('.page').data('querystring') : '';

        var urlParams = {
            localeCode: localeCode,
            action: action,
            query: querystring,
            type: type,
            geoloc: true
        };

        url = appendToUrl(url, urlParams);

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (response) {
            },
            error: function (_err) {
            }
        });

        $('body').trigger('analytics:pushgeolocationbanner', {eventCategory: 'checklocale', eventAction: 'close', eventLabel: localeCode});
    });

    $(document).on('click', '.js-changelocale-overlay, .js-changelocale-popup-close', function (e) {
        e.preventDefault();

        $('.js-locale-popup').hide();
        $('.js-locale-switch-popup').hide();
        $('body').removeClass('cc-blocked');
        var localeCode = $('.js-changelocale-popup-content').attr('data-currentlocale');
        $('body').trigger('analytics:pushgeolocationbanner', {eventCategory: 'changelocale', eventAction: 'close', eventLabel: localeCode});
    });

    $(document).on('change', '.js-locale-popup-form-country-select', function (e) {
        e.preventDefault();

        // var action = $('.page').data('action');
        var localeCode = $(this).find(':selected').data('locale');
        // var localeCurrencyCode = $(this).data('currencycode');
        // var queryString = $('.page').data('querystring');
        var url = $('.js-changelocale-popup-content').data('url');
        var urlParams = {
            localeCode: localeCode
        };

        url = appendToUrl(url, urlParams);

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (response) {
                $('#js-locale-popup-form-language-select').selectpicker().find('option').remove().selectpicker('refresh');
                for (var i = 0; i < response.locale.curLangs.length; i++) {
                    $('#js-locale-popup-form-language-select').append('<option ' + response.locale.curLangs[i].isDefault + ' data-locale=' + response.locale.curLangs[i].localID + ' data-countrycode=' + response.locale.countryCode + '>' + response.locale.curLangs[i].displayLanguage + '</option>').selectpicker('refresh');
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
            }
        });
    });

    $(document).on('click', '.js-locale-popup-form-button-link', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var localeCode = $('#js-locale-popup-form-language-select').find(':selected').data('locale');
        var countryCode = $('#js-locale-popup-form-language-select').find(':selected').data('countrycode');
        var type = $(this).data('type');
        var action = $('.page').data('action') !== null ? $('.page').data('action') : '';
        var querystring = $('.page').data('querystring') !== null ? $('.page').data('querystring') : '';

        var urlParams = {
            localeCode: localeCode,
            countryCode: countryCode,
            type: type,
            action: action,
            query: querystring,
            geoloc: false,
            cookieSave: true
        };

        url = appendToUrl(url, urlParams);

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (response) {
                if (response && response.redirectUrl) {
                    $('body').trigger('analytics:pushgeolocationbanner', {eventCategory: 'changelocale', eventAction: 'confirm', eventLabel: localeCode });
                    window.location.href = response.redirectUrl;
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
            }
        });
    });

    $(document).on('click', '.js-locale-international-form-button-link', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var localeCode = $('#js-locale-popup-form-language-select').find(':selected').data('locale');
        var countryCode = $('#js-locale-popup-form-language-select').find(':selected').data('countrycode');
        var type = $(this).data('type');
        var action = 'Home-Show';
        var querystring = $('.page').data('querystring') !== null ? $('.page').data('querystring') : '';

        var urlParams = {
            localeCode: localeCode,
            countryCode: countryCode,
            type: type,
            action: action,
            query: querystring,
            geoloc: false,
            cookieSave: true
        };

        url = appendToUrl(url, urlParams);

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (response) {
                if (response && response.redirectUrl) {
                    window.location.href = response.redirectUrl;
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
            }
        });
    });

    $(document).on('change', '.js-switch-locale-popup-form-country-select', function(e) {
        e.preventDefault();
        var country = $('.js-switch-locale-popup-form-country-select').find(':selected').data('country');
        $('.js-locale-popup-form-title-countryname').text(country);
    });

    $(document).on('click', '.js-switch-locale-popup-form-button-link', function (e) {
        e.preventDefault();

        var localeCode = $('.js-switch-locale-popup-form-country-select').find(':selected').data('locale');
        var country = $('.js-switch-locale-popup-form-country-select').find(':selected').data('country');
        var countryCode = $('.js-switch-locale-popup-form-country-select').find(':selected').data('countrycode');

        $('.js-locale-popup-form-title-countryname-yesno').text(country);

        var url = $(this).data('action');
        var action = $('.page').data('action') !== null ? $('.page').data('action') : '';

        var data = {
            localeCode: localeCode,
            country: country,
            countryCode: countryCode,
            action: action
        };

        url = appendToUrl(url, data);

        $.ajax({
            url: url,
            type: 'get',
            datatype: 'json',
            success: function (response) {
                if (response && response.redirectUrl) {
                    $('body').trigger('analytics:pushgeolocationbanner',
                        {eventCategory: 'checklocale', eventAction: 'confirmchange',
                            eventLabel: localeCode.indexOf('_') > 0 ? localeCode.substring(localeCode.indexOf('_') + 1) : localeCode });
                    window.location.href = response.redirectUrl;
                }
            },
            error: function (err) {
            }

        });
    });

    $(document).on('click', '.js-locale-popup-backtoconfirm', function(e) {
        e.preventDefault();

        $('.js-locale-popup-content-yesno').hide();
        $('.js-locale-popup-content').show();
        $('body').trigger('analytics:pushgeolocationbanner', {eventCategory: 'checklocale', eventAction: 'change', eventLabel: ''});
    });

    $(document).on('click', '.js-switch-locale-popup-form-button-link-yesno', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var localeCode = $('.js-locale-popup-form-title-countryname-yesno').data('locale');
        var type = $(this).data('type');
        var action = $('.page').data('action') !== null ? $('.page').data('action') : '';
        var querystring = $('.page').data('querystring') !== null ? $('.page').data('querystring') : '';

        if (type === 'no') {
            localeCode = $('.js-locale-mylocale').data('mylocale');
        }

        var urlParams = {
            localeCode: localeCode,
            action: action,
            query: querystring,
            type: type,
            geoloc: true
        };

        url = appendToUrl(url, urlParams);

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (response) {
                if (response && response.redirectUrl && response.redirectUrl !== 'no') {
                    $('body').trigger('analytics:pushgeolocationbanner',
                        {eventCategory: 'checklocale', eventAction: 'confirm',
                            eventLabel: localeCode.indexOf('_') > 0 ? localeCode.substring(localeCode.indexOf('_') + 1) : localeCode });
                    window.location.href = response.redirectUrl;
                } else {
                    $('.js-locale-popup').hide();
                    $('.js-locale-switch-popup').hide();
                    $('body').removeClass('cc-blocked');
                    $('body').trigger('analytics:pushgeolocationbanner', {eventCategory: 'checklocale', eventAction: 'close', eventLabel: localeCode});
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
            }
        });
    });

    $(document).ready(function () {
        if ($('.js-locale-switch-popup').data('isvisible') == true) {
            $('body').addClass('cc-blocked');
        }
    });
};
